// import { useDispatch } from "react-redux";
// import { addTourImage } from "../slices/tourSlice";
// import { useState, useRef } from "react";

// const ImageModal = ({ isOpen, onClose, selectedTour }) => {
//   const dispatch = useDispatch();
//   const [file, setFile] = useState(null);

//   const fileInputRef = useRef(null);
//   const [preview, setPreview] = useState(null);

//   const handleDivClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setPreview(URL.createObjectURL(file)); // Şəkil önizləmə üçün
//       console.log("Seçilmiş fayl:", file.name);
//     }
//   };

//   const handleSubmit = async () => {};
//   return (
//     <>
//       <div className="modal-overlay">
//         <div className="modal-content">
//           <button className="close-btn" onClick={onClose}>
//             ✖
//           </button>
//           <div>
//             <div
//               onClick={handleDivClick}
//               style={{
//                 width: "150px",
//                 height: "150px",
//                 border: "2px dashed gray",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 cursor: "pointer",
//               }}
//             >
//               {preview ? (
//                 <img
//                   src={preview}
//                   alt="Preview"
//                   style={{ width: "100%", height: "100%" }}
//                 />
//               ) : (
//                 "Şəkil Seç"
//               )}
//             </div>
//             <input
//               type="file"
//               ref={fileInputRef}
//               onChange={handleFileChange}
//               accept="image/*"
//               style={{ display: "none" }} // Input gizlədilir
//             />
//           </div>
//           <button className="submit-btn" onClick={handleAssignRole}>
//             Təyin et
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

import { useDispatch } from "react-redux";
import { addTourImage } from "../slices/tourSlice";
import { useState, useRef } from "react";

const ImageModal = ({ isOpen, onClose, selectedTour }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file)); // Şəkil önizləmə üçün
      setFile(file); // Seçilen dosyayı state'e kaydediyoruz
    }
  };

  const handleSubmit = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("ImageFile", file);
      formData.append("TourId", selectedTour.id); // Seçilen turun ID'si ekleniyor

      // API'ye dosya gönderme
      await dispatch(addTourImage(formData));
      onClose(); // Modalı kapatıyoruz
    }
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <button className="close-btn" onClick={onClose}>
            ✖
          </button>
          <div>
            <div
              onClick={handleDivClick}
              style={{
                width: "150px",
                height: "150px",
                border: "2px dashed gray",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {preview ? (
                <img
                  src={preview}
                  alt="Preview"
                  style={{ width: "100%", height: "100%" }}
                />
              ) : (
                "Şəkil Seç"
              )}
            </div>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/*"
              style={{ display: "none" }} // Input gizlədilir
            />
          </div>
          <button className="submit-btn" onClick={handleSubmit}>
            Təyin et
          </button>
        </div>
      </div>
    </>
  );
};

export default ImageModal;
